module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_314635.de2bc2dd.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetATF/FormatoSimplificado_314635.pdf
// module id = 812
// module chunks = 0